var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, default as React } from "react";
import { footerTranslations } from "./i18n";
import Dialog from "../components/dialog";
import FlexContainer from "../grid/flexcontainer";
import TextArea from "../components/textarea";
import { bind } from "decko";
import Panel from "../components/panel";
import DialogFooter from "../components/dialogfooter";
import { axiosPost } from "../helper/axios";
import { getCurrentDomain } from "../helper/domain";
import { isBeta } from "../menu/beta";
import Button from "../components/button";
import { RevoTooltip } from "../components/revo-tooltip";
import { scopesFromCookie } from "../helper/scopesfromcookie";
export var SendingStatus;
(function (SendingStatus) {
    SendingStatus[SendingStatus["Start"] = 0] = "Start";
    SendingStatus[SendingStatus["Done"] = 1] = "Done";
    SendingStatus[SendingStatus["Error"] = 2] = "Error";
})(SendingStatus || (SendingStatus = {}));
export class Footer extends Component {
    constructor(props) {
        super(props);
        this.translations = footerTranslations();
        this.state = {
            year: new Date().getFullYear(),
            dialogOpen: false,
            feedbackMessage: "",
            errorMessage: null,
            sendingStatus: null,
            domain: getCurrentDomain(window.location),
        };
    }
    changeFeedbackMessage(message) {
        this.setState({
            feedbackMessage: message,
        });
    }
    sendFeedback() {
        if (this.state.feedbackMessage !== "") {
            const feedback = {
                message: this.state.feedbackMessage,
                url: window.location.href,
                beta: isBeta(),
                window: {
                    width: window.innerWidth,
                    height: window.innerHeight,
                },
            };
            this.setState({
                sendingStatus: SendingStatus.Start,
                errorMessage: null,
            });
            const call = {
                domain: this.state.domain,
                serviceName: "backoffice",
                pathWithoutLeadingSlash: "api/feedbacks",
            };
            axiosPost(call, { withCredentials: true }, feedback, {}).then((success) => {
                this.setState({ sendingStatus: SendingStatus.Done });
            }, (error) => {
                const errorMessage = error.response && error.response.status === 401
                    ? this.translations.error.unauthorized
                    : this.translations.error.sendingFailed;
                this.setState({
                    sendingStatus: SendingStatus.Error,
                    errorMessage: errorMessage,
                });
            });
        }
    }
    closeDialog() {
        this.setState({
            dialogOpen: false,
            feedbackMessage: "",
            errorMessage: null,
            sendingStatus: null,
        });
    }
    renderDialog() {
        return (React.createElement(Dialog, { icon: "announcement", title: this.translations.feedback, closeButton: true, onClose: this.closeDialog },
            React.createElement(FlexContainer, { paddingX: "lg", paddingY: "xxl", direction: "col" },
                this.state.sendingStatus === SendingStatus.Done && (React.createElement(Panel, { color: "positive" }, this.translations.feedbackSuccessfullySent)),
                this.state.sendingStatus !== SendingStatus.Done && (React.createElement(TextArea, { label: this.translations.message, autoFocus: true, value: this.state.feedbackMessage, onValueChange: this.changeFeedbackMessage, rows: 5 })),
                this.state.sendingStatus === SendingStatus.Error && (React.createElement(Panel, { color: "negative" }, this.state.errorMessage))),
            this.state.sendingStatus === SendingStatus.Done ? (React.createElement(DialogFooter, { "md-justify": "center", spaceBetween: "md", paddingX: "lg", paddingY: "lg" },
                React.createElement(Button, { type: "secondary", onClick: this.closeDialog }, this.translations.close))) : (React.createElement(DialogFooter, { "md-justify": "center", spaceBetween: "md", paddingX: "lg", paddingY: "lg" },
                React.createElement(Button, { type: "secondary", onClick: this.closeDialog }, this.translations.cancel),
                React.createElement(Button, { type: "primary", onClick: this.sendFeedback, disabled: this.state.feedbackMessage === "" ||
                        this.state.sendingStatus === SendingStatus.Start }, this.translations.submit)))));
    }
    render() {
        return (React.createElement("div", { className: "re-footer" },
            React.createElement("span", null,
                "Copyright \u00A9 ",
                this.state.year,
                " 21",
                React.createElement("sup", null, "st"),
                " Real Estate GmbH"),
            React.createElement("span", { className: "version" }, "BETA-Version"),
            React.createElement("span", null, this.translations.tooltipLabel),
            React.createElement("span", { className: "feedback", id: "joyride-feedback" },
                React.createElement(RevoTooltip, { text: this.translations.tooltipText, position: "up" }, scopesFromCookie().length ? (React.createElement(Button, { type: "tertiary", icon: "announcement", onClick: (e) => {
                        e.preventDefault();
                        this.setState({ dialogOpen: true });
                    } })) : (React.createElement(Button, { type: "tertiary", icon: "announcement", onClick: (e) => {
                        e.preventDefault();
                        window.open("mailto:support@21re.de?subject=21st Platform - Feedback");
                    }, href: "mailto:support@21re.de?subject=21st Platform - Feedback" })))),
            this.state.dialogOpen ? this.renderDialog() : null));
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Footer.prototype, "changeFeedbackMessage", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Footer.prototype, "sendFeedback", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Footer.prototype, "closeDialog", null);
export default Footer;
//# sourceMappingURL=footer.js.map